import { render } from "./StatementModal.vue?vue&type=template&id=72caa837&scoped=true&ts=true&lang=pug"
import script from "./StatementModal.vue?vue&type=script&lang=ts"
export * from "./StatementModal.vue?vue&type=script&lang=ts"

import "./StatementModal.vue?vue&type=style&index=0&id=72caa837&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72caa837"]])

export default __exports__